
/**
 * 状态对象模块
 * */ 
import localStorageUtil from '@/utils/localStorage'

export default {
    todos:localStorageUtil.readTodos()
};


// WEBPACK FOOTER //
// ./src/store/state.js